import clsx from 'clsx';
import { useAccordion } from './index';

interface AccordionPanelProps extends BaseProps {}

export const AccordionPanel = ({
  children,
  className,
  ...rest
}: AccordionPanelProps) => {
  const { expanded } = useAccordion();

  if (!expanded) return null;

  return (
    <div className={clsx(className, 'p-4 overflow-hidden')} {...rest}>
      {children}
    </div>
  );
};
